import React, { useState } from 'react';
import { Card, Box, Flex, Text, Badge, SegmentedControl, Stack, Skeleton } from '@mantine/core';
import { PiWarningCircle, PiChartLineUp, PiWifiHighBold, PiWarningDiamondBold } from 'react-icons/pi';
import Record from './Record';
import RowRenovation from './RowRenovation';
import dayjs from 'dayjs';

export const OperationsFeed = ({ records, renovations, onToggleRollback }) => {
  const [activeTab, setActiveTab] = useState('lastRenovation');
  const today = dayjs().format('YYYY-MM-DD');
  const tenDays = dayjs().add(10, 'day').format('YYYY-MM-DD');

  const isLastRenovation = activeTab === 'lastRenovation';

  const getTitle = () => {
    return isLastRenovation ? 'OPERACIONES EN TIEMPO REAL' : 'MONITOR DE EXPIRACIONES';
  };

  const getBadgeColor = () => {
    return isLastRenovation ? 'green' : 'orange';
  };

  return (
    <Box>
      <Box mb="md">
        <SegmentedControl
          fullWidth size="md" radius="md"
          value={ activeTab }
          onChange={ setActiveTab }
          color="yellow"
          data={ [
            { label: 'Transacciones', value: 'lastRenovation' },
            { label: 'Expiraciones', value: 'next' },
          ] }
        />
      </Box>

      <Card padding={ 0 } radius="lg" withBorder shadow="sm" className="overflow-hidden">
        <Box p="md" bg="gray.0" style={{ borderBottom: '1px solid var(--mantine-color-gray-2)' }}>
          <Flex justify="space-between" align="center">
            <Text size="xs" fw={ 900 } tt="uppercase" className="tracking-widest">
              { getTitle() }
            </Text>
            <Badge 
              variant="filled" 
              color={getBadgeColor()} 
              size="lg" 
              radius="md"
              leftSection={isLastRenovation ? <PiWifiHighBold size={16} /> : <PiWarningDiamondBold size={16} />}
              styles={{
                root: { paddingLeft: '12px', paddingRight: '12px', height: '28px' },
                label: { fontWeight: 800, fontSize: '11px', letterSpacing: '0.5px' }
              }}
            >
              {isLastRenovation ? 'SISTEMA ONLINE' : 'ATENCIÓN REQUERIDA'}
            </Badge>
          </Flex>
        </Box>

        <Box p="xs" style={{ minHeight: '400px' }}>
          { isLastRenovation ? (
            <Stack gap={0}>
              { records ? records.slice(0, 8).map((item) => (
                <Record key={ item._id } item={ item } rollBackRenovation={ onToggleRollback } />
              )) : <FeedSkeletons /> }
            </Stack>
          ) : (
            <Stack gap={0}>
              { renovations ? renovations.slice(0, 8).map((item) => (
                <RowRenovation key={ item._id } item={ item } today={ today } tenDays={ tenDays } />
              )) : <FeedSkeletons /> }
            </Stack>
          )}
        </Box>
      </Card>
    </Box>
  );
};

const FeedSkeletons = () => (
  <Stack gap="xs">
    {Array.from({ length: 6 }).map((_, i) => (
      <Skeleton key={i} height={60} radius="md" />
    ))}
  </Stack>
);
